import React from 'react';
import Navbar from './Navbar';
import Roadmap from './Roadmap';
import potuslogo from '../assets/potuslogo.png';
import takeastep from '../assets/takeastep.png';
import love from '../assets/love.png';
import Tokenomics from './Tokenomics';
import loveq from '../assets/loveq.png';
import whouse from '../assets/whouse.gif';
import trun from '../assets/trun.gif';

function MainApp() {
  return (
    <div className="App">
      <Navbar />
      <header className="header">
        <h1
          style={{
            fontSize: "100px",
            fontWeight: "bold",
            color: "black",
            textAlign: "center",
            marginTop: "100px",
          }}>
          <img
            src={loveq}
            alt="love"
            className="love"
            height="100px"
            width="100px"
            style={{
              marginRight: "5px",
              marginTop: "25px",
              position: "relative",
            }}
          />
          POTUS 2025
        </h1>
      </header>
      <div className="container">
        <h2>Developed by Community</h2>
      </div>
      <div className="image-row">
        <img
          src={whouse}
          alt="White House"
          className="inline-image"
          height="200px"
          width="300px"
        />
      </div>
      <div className="container">
        <a
          href="https://pump.fun"
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link">
          <img
            src={takeastep}
            alt="POTUS COIN"
            className="logo"
            height="200px"
            width="300px"
          />
        </a>
      </div>

      <div className="container"></div>
      <h1>
        BEFORE JAN 20TH 2025
        <img
          src={love}
          alt="love"
          className="love"
          height="30px"
          width="30px"
          style={{
            marginRight: "10px",
            marginTop: "px",
            position: "relative",
          }}
        />
      </h1>

      <div className="container">
        <h2 className="disclaimer">
          We are not associated with the POTUS 2025 campaign. we are a meme coin
          with no intrinsic value or expectation of financial return. I will
          continue update community with the latest POTUS news. share your
          thoughts and ideas.{" "}
        </h2>
      </div>
      <img
        src={potuslogo}
        alt="POTUS COIN"
        className="logo"
        height="190px"
        width="350px"
      />
      <p className="lets-2025">LETS GO POTUS 2025</p>
      <Tokenomics />
      <Roadmap />
      <div className="snow-container">
        <img
          src={trun}
          alt="trump"
          className="inline-image"
          height="200px"
          width="300px"
        />
        <div className="snow"></div>
      </div>
    </div>
  );
}

export default MainApp; 